import { SVGProps } from 'react';

export const Rotate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    fill="currentColor"
    {...props}
  >
    <path d="M94 187.1C120.8 124.1 183.3 80 256 80c39.7 0 77.8 15.8 105.9 43.9l4.1 4.1-35.7 35.7c-6.6 6.6-10.3 15.6-10.3 25 0 19.5 15.8 35.3 35.3 35.3H472c13.3 0 24-10.7 24-24V83.3c0-19.5-15.8-35.3-35.3-35.3-9.4 0-18.3 3.7-25 10.3L400 94.1l-4.1-4.1C358.8 52.8 308.5 32 256 32 163.4 32 83.9 88.2 49.8 168.3c-5.2 12.2.5 26.3 12.7 31.5s26.3-.5 31.5-12.7zm368 157c5.2-12.2-.4-26.3-12.6-31.5s-26.3.4-31.5 12.6C391 388.1 328.6 432 256 432c-39.7 0-77.8-15.8-105.9-43.9L146 384l35.7-35.7c6.6-6.6 10.3-15.6 10.3-25 0-19.5-15.8-35.3-35.3-35.3H40c-13.3 0-24 10.7-24 24v116.7c0 19.5 15.8 35.3 35.3 35.3 9.4 0 18.3-3.7 25-10.3l35.7-35.8 4.1 4.1c37.1 37.2 87.4 58 139.9 58 92.5 0 171.8-56 206-135.9zM448 176h-62.1l62.1-62.1V176zM64 336h62.1L64 398.1V336z" />
  </svg>
);
